/**
 * Adds a global event listener to a parent element. The event listener triggers when the event occurs on a child element that matches the provided selector.
 *
 * @param {Element} parent - The parent element to attach the event listener to.
 * @param {string} eventName - The event to listen for.
 * @param {string} selector - The selector to match against. When the event occurs on an element that matches this selector, the event handler will be triggered.
 * @param {Function} handler - The function to execute when the event occurs. This function is called with the context set to the closest ancestor of the event target that matches the selector, and with the provided arguments.
 * @param {...any} args - Additional arguments to pass to the event handler.
 */

export default function addGlobalEvent(parent, eventName, selector, handler, ...args) {
  parent?.addEventListener(
    eventName,
    function eventHandlerWrapper(event) {
      const target = event.target.closest(selector)
      if (target) {
        handler.call(target, event)
      }
    },
    false,
  )
}
